// src/store/deliverySlice/deliveryApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const deliveryApi = createApi({
  reducerPath: "deliveryApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Delivery"],
  endpoints: (builder) => ({
    requestDelivery: builder.mutation({
      query: (payload) => ({
        url: "/deliveries",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Delivery"],
    }),
    getAvailableDeliveries: builder.query({
      query: () => "/deliveries/available",
      providesTags: ["Delivery"],
    }),
    acceptDelivery: builder.mutation({
      query: ({ deliveryId, driverId }) => ({
        url: `/deliveries/${deliveryId}/accept`,
        method: "POST",
        body: { driverId },
      }),
      invalidatesTags: ["Delivery"],
    }),
    fetchDeliveryStatus: builder.query({
      query: (deliveryId) => `/deliveries/${deliveryId}`,
      providesTags: (result, error, id) => [{ type: "Delivery", id }],
    }),
    getDeliveryRequest: builder.query({
      query: (id) => `/deliveries/${id}`,
      providesTags: (result, error, id) => [{ type: "Delivery", id }],
    }),
  }),
});

export const {
  useRequestDeliveryMutation,
  useGetAvailableDeliveriesQuery,
  useAcceptDeliveryMutation,
  useFetchDeliveryStatusQuery,
  useGetDeliveryRequestQuery,
} = deliveryApi;
